(() => {
 if (customElements.get('ritual-flip-card')) return;
 class RitualFlipCard extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const open = this.querySelector('[data-rat-open]');
   const close = this.querySelector('[data-rat-close]');
   const back = this.querySelector('.rat-flip__back');
   if (!open || !close || !back) return;
   const setOpen = (expanded) => {
    this.classList.toggle('is-open', expanded);
    open.setAttribute('aria-expanded', String(expanded));
    open.setAttribute('aria-hidden', String(expanded));
    open.inert = expanded;
    back.inert = !expanded;
    back.setAttribute('aria-hidden', String(!expanded));
    (expanded ? close : open).focus({preventScroll:true});
   };
   const options = {signal:this.controller.signal};
   open.addEventListener('click', () => setOpen(true), options);
   close.addEventListener('click', () => setOpen(false), options);
   this.addEventListener('keydown', (event) => {
    if(event.key === 'Escape' && this.classList.contains('is-open')) {
     event.preventDefault(); setOpen(false);
    }
   }, options);
  }
  disconnectedCallback() {this.controller?.abort(); this.controller = null;}
 }
 customElements.define('ritual-flip-card', RitualFlipCard);
})();
